import React from "react";
import { Collapse } from "antd";
import Textarea from "@atlaskit/textarea";

const ActionDescription = ({ description, onChange }) => {
  const { Panel } = Collapse;

  return (
    <div style={{ marginTop: 8, marginLeft: -14 }}>
      <Collapse defaultActiveKey={[]} ghost size="small">
        <Panel header="Description" key="action-description">
          <Textarea name="actionDescription" onChange={onChange} value={description || ""} maxLength={500} minRows={3} />
        </Panel>
      </Collapse>
    </div>
  );
};

export default ActionDescription;
